module.exports = __webpack_public_path__ + "static/media/path2.43ff45c5.png";